export const REPORTING_FETCH_PNMS_TO_CONFIRM = 'REPORTING_FETCH_PNMS_TO_CONFIRM';
export const REPORTING_FETCH_PNMS_TO_CONFIRM_INIT = 'REPORTING_FETCH_PNMS_TO_CONFIRM_INIT';
export const REPORTING_FETCH_PNMS_TO_CONFIRM_DONE = 'REPORTING_FETCH_PNMS_TO_CONFIRM_DONE';

export const REPORTING_CONFIRM_PNMS = 'REPORTING_CONFIRM_PNMS';
export const REPORTING_CONFIRM_PNMS_INIT = 'REPORTING_CONFIRM_PNMS_INIT';
export const REPORTING_CONFIRM_PNMS_DONE = 'REPORTING_CONFIRM_PNMS_DONE';
